import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  href = 'https://vidaenvirtud.com/42524735078462:1',
  className = ''
}: CTAButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-xl md:text-2xl font-bold text-white transition-all bg-green-700 rounded-xl hover:bg-green-800 hover:scale-105 shadow-lg hover:shadow-xl ${className}`} data-id="element-389">
      {text}
      <ArrowRight className="w-6 h-6 ml-3" data-id="element-390" />
    </a>;
}